(function () {
  const showModalAttribute = 'data-show-modal';
  const hideModalAttribute = 'data-hide-modal';
  const modalOverlayAttribute = 'data-modal-overlay';

  const mobileBreakpoint = 758;

  let swipeStartPos = null;
  let swipeEndPos = null;

  window.showModal = name => {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    const overlay = getModalOverlay(name);
    if (!overlay) {
      return;
    }
  
    overlay.classList.add('visible');
    window.dispatchEvent(new CustomEvent('modal:open', {detail: {name}}));
  }
  
  window.hideModal = name => {
    document.body.style.overflow = 'auto';
    document.documentElement.style.overflow = 'auto';

    
    const overlay = getModalOverlay(name);
    if (!overlay) {
      return;
    }

    if (isMobile()) {
      hideModalOnMobile(overlay);
    } else {
      overlay.classList.remove('visible');
    }

    window.dispatchEvent(new CustomEvent('modal:hide', {detail: {name}}));
  }

  function getModalOverlay (name) {
    return document.body.querySelector(`[${modalOverlayAttribute}="${name}"]`);
  }

  function hideModalOnMobile (overlay) {
    overlay.firstElementChild.style.bottom = `-1000px`;
    overlay.classList.remove('visible');
    setTimeout(function () {
      overlay.firstElementChild.style.bottom = `0`;
    }, 300);
  }

  function getTouch (e) {
    return e.touches ? e.touches[0] : e.changedTouches[0];
  }

  function isMobile () {
    return document.documentElement.clientWidth <= mobileBreakpoint;
  }
  
  document.body.addEventListener('click', function (e) {
    if (e.target.hasAttribute(modalOverlayAttribute)) {
      hideModal(e.target.dataset.modalOverlay);
      document.body.querySelector('mouse-cursor')?.classList.remove('active');
      return;
    }

    const toggler = e.target.closest(`[${showModalAttribute}], [${hideModalAttribute}]`);
    if (!toggler) {
      return;
    }

    e.preventDefault();
    
    if (toggler.matches(`[${showModalAttribute}]`)) {
      showModal(toggler.dataset.showModal);
    } else {
      hideModal(toggler.dataset.hideModal);
    }
  });

  document.addEventListener('touchstart', function (e) {
    if (!e.target.closest('.mobile-line-container')) {
      return;
    }

    const overlay = document.body.querySelector('.modal-overlay.visible');
    overlay.firstElementChild.classList.add('no-transition');
    swipeStartPos = getTouch(e).pageY;
  });

  document.addEventListener('touchmove', function (e) {
    if (swipeStartPos === null) {
      return;
    }

    const overlay = document.body.querySelector('.modal-overlay.visible');
    if (!overlay) {
      return;
    }

    swipeEndPos = getTouch(e).pageY;
    overlay.firstElementChild.style.bottom = `-${swipeEndPos - swipeStartPos}px`;
  });

  document.addEventListener('touchend', function (e) {
    if (swipeStartPos === null) {
      return;
    }

    const overlay = document.body.querySelector('.modal-overlay.visible');
    if (!overlay) {
      return;
    }

    overlay.firstElementChild.classList.remove('no-transition');
    
    if ((swipeEndPos - swipeStartPos) >= 100) {
      hideModal(overlay.dataset.modalOverlay);
    } else {
      overlay.firstElementChild.style.bottom = '0';
    }

    swipeStartPos = null;
    swipeEndPos = null;
  });
})();